export var PlayerRole;
(function (PlayerRole) {
    PlayerRole["PLAYER"] = "player";
    PlayerRole["AUDIENCE"] = "audience";
})(PlayerRole || (PlayerRole = {}));
export var PlayerStatus;
(function (PlayerStatus) {
    PlayerStatus["CONNECTED"] = "connected";
    PlayerStatus["DISCONNECTED"] = "disconnected";
})(PlayerStatus || (PlayerStatus = {}));
//# sourceMappingURL=player.js.map